export const animations = {
  fadeIn: 'animate__animated animate__fadeIn',
  fadeOut: 'animate__animated animate__fadeOut',
  fadeTop: 'animate__animated animate__fadeInUp',
  fadeBottom: 'animate__animated animate__fadeInDown',
  fadeRight: 'animate__animated animate__fadeInRight',
  fadeLeft: 'animate__animated animate__fadeInLeft',
  //shake
  shake: 'animate__animated animate__shakeX',
  ruber: 'animate__animated animate__rubberBand',
  pulse: 'animate__animated animate__pulse', 
  bounce: 'animate__animated animate__bounce', 
  //slide
  slideDown: 'animate__animated animate__slideInDown', 
  //slide

}